<p-panel>
    @if (isReactiveFormReady) {
        <app-reactive-form-builder
            #builderRef
            [form]="form.formFields"
            [id]="reactiveFormRecordId"
            [previousData]="initialPreviousData"
            [request]="request"
            [getRequest]="trabajadoresApi.trabajadoresGET"
            [undoEnabled]="undoEnabled"
            (stableValueChanges)="stableValueChanges($event)"
            (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
            (afterSend)="onAfterSend($event)"
            (goBack)="goBack()">
        </app-reactive-form-builder>
    } @else if (reactiveFormLoadingError) {
        <div class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    } @else {
        <div class="alert alert-info mb-0" role="status" aria-live="polite">
            Cargando datos del formulario...
        </div>
    }
</p-panel>
